export const PaymentGatewayEnum = Object.freeze({
  'STRIPE': 'stripe',
  'BRAINTREE': 'braintree',
  'BLUESNAP': 'bluesnap',
})
